export default __webpack_public_path__ + "static/media/Orders.99dfe00f.svg";